import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, ChevronRight } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../lib/i18n";

export function ReviewInviteBanner() {
  const { t } = useLang();
  const nav = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get("/orders/mine").then((r) => {
      const pending = (r.data || []).find((o) => o.status === "pagato" && !o.rating);
      setOrder(pending || null);
    }).catch(() => {});
  }, []);

  if (!order) return null;

  return (
    <button data-testid="review-invite-banner" onClick={() => nav(`/ordine/${order.id}`)}
      className="card-hover mt-3 flex w-full items-center gap-3 rounded-2xl border border-amber-300 bg-amber-50 p-3 text-left">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-400/20"><Star className="h-5 w-5 fill-amber-400 text-amber-400" /></div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-amber-900">{t("review_invite_title")}</p>
        <p className="text-xs text-amber-700">{t("review_invite_cta")} · {order.code}</p>
      </div>
      <ChevronRight className="h-5 w-5 shrink-0 text-amber-500" />
    </button>
  );
}
